
<template>
  <div class="signup app-content bg-blue">

    <b-toast id="new-message-toast" title="新着メッセージがあります" variant="info" solid no-auto-hide toaster="b-toaster-top-center">
      <a @click="fetch_messages(current_organization)">こちらをクリックして、メッセージを読み込みましょう</a>
    </b-toast>

    <div class="bg-blue pb-5">
      <div class="container bg-blue">
        <div class="row mx-0 pb-2 sm-none">
          <div class="col-12 p-0">
            <router-link :to="'./job_mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'./mailbox'">
              <p class="text-dark font14 under" style="display: inline;">チャット</p>
            </router-link>
          </div>
        </div>
        <div class="row md-none">
          <div class="col-md-8 col-sm-12 pb-3" :class="mobileCss('chatbox')" @click="mobileViewMode = 'list'">
            <router-link :to="'./mailbox'">
              <p class="text-dark font14 under" style="display: inline;">＜ チャットリストに戻る </p>
            </router-link>
          </div>
        </div>

        <div class="row pt-0 mb-2">
          <div class="col-md-4 col-sm-12" :class="mobileCss('chatbox')">
          </div>
          <div class="col-md-8 col-sm-12" :class="mobileCss('chatbox')">
            <div class="row pl-250px mx-auto">
              <b-img class="logo_img" :src="current_organization.logo_img" rounded="circle" alt="Circle image"></b-img>
              <p class="contact-name current-mail pl-2">
                <span class="contact-description">{{ current_organization.caption }}</span><br/>
                  {{ current_organization.name }} 
              </p>
            </div>
            <div class="row pl-250px ml-5 pt-2 pb-4 sm-none">
              <router-link :to="'./jobs/' + recruit.job_id">
                <b-button class='table-edit-button '>求人を見る</b-button>
              </router-link>
            </div>
          </div>

          <div class="col-md-4 col-sm-12" :class="mobileCss('list')">
            <b-list-group class="mail-box-list">
              <h2 class="box-title">応募企業リスト</h2>
              <p class="sub-title">クリックで切り替わります</p>
              <b-list-group-item class='my-2 contact-line' v-for="l in lists" :key="l">
                <div class="row" @click="fetch_messages(l); mobileViewMode = 'detail'">
                    <b-img :src="l.logo_img" rounded="circle" class="logo_img" alt="Circle image"></b-img>
                    <p class="contact-name">
                        {{ l.name }} 
                        <br/><span class="contact-description">{{ l.title }}</span>
                    </p>
                    <b-badge v-show="l.count > 0" class="ml-auto mt-auto mb-auto unread-circle" variant="warning">{{ l.count }}</b-badge>
                </div>
              </b-list-group-item>
            </b-list-group>
          </div>
          <div class="col-md-8 col-sm-12" :class="mobileCss('chatbox')">
                <b-row v-if="messages.length == 0">
                   <b-card-text>メッセージのやりとりはまだありません</b-card-text>
                </b-row>
                <b-row v-else>
                  <div v-show="recruit.fase == 'waiting_interview'" class="col-12 text-center pb-4">
                    <router-link :to="'./jobs/' + recruit.job_id">
                      <b-button class='table-edit-button '>求人を見る</b-button>
                    </router-link>
                    <b-button @click="cancelInterview" class='orange-button'>面接をキャンセル</b-button>
                  </div>

                  <div class="message-cotainer row" id="messageBox">

                    <div v-for="m in messages" :key="m" class="col-12">
                      <div v-if="m.from == 'aelu'" class="text-center mx-auto">
                        <p class="mb-1 mt-3">{{ formatDate2(m.created_at) }}</p>
                        <b-alert class="w75 mx-auto" variant="secondary" show><p>{{ m.message }}</p></b-alert>
                      </div>
                      <div v-if="m.from == 'user'" class="float-right row">
                      <p class="mb-1 mt-3">{{ formatDate(m.created_at) }}</p>
                        <b-alert v-if="m.message_type == 'text'" class="org-message-baloon" variant="info" show>{{ m.message }}</b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && (m.file_type=='.xlsx' || m.file_type=='.pdf')" class="org-message-baloon" variant="info" show><a target="_blank" :href="m.file_path"><b-icon icon="download" class="mr-2"></b-icon>{{ m.file_name }}</a></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.jpg'" class="org-message-baloon" variant="info" show><img class="w100" :src="m.file_path"/></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.png'" class="org-message-baloon" variant="info" show><img  class="w100" :src="m.file_path"/></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.mp4'" class="org-message-baloon" variant="info" show><img  class="w100">
                          <video controls autoplay class="video">
                            <source :src="m.file_path" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
                          </video>
                        </b-alert>

                      </div>
                      <div v-if="m.from == 'organization'" class="float-left row">
                        <b-img class="logo_img" :src="m.logo_img" rounded="circle" alt="Circle image"></b-img>
                        <b-alert v-if="m.message_type == 'text'" class="user-message-baloon ml-3" variant="dark" show>{{ m.message }}</b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && (m.file_type=='.xlsx' || m.file_type=='.pdf')" class="user-message-baloon ml-3" variant="dark" show><a target="_blank" :href="m.file_path"><b-icon icon="download" class="mr-2"></b-icon>{{ m.file_name }}</a></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.jpg'" class="user-message-baloon ml-3" variant="dark" show><img class="w100" :src="m.file_path"/></b-alert>
                        <b-alert v-else-if="m.message_type == 'file' && m.file_type=='.png'" class="user-message-baloon ml-3" variant="dark" show><img  class="w100" :src="m.file_path"/></b-alert>

                        <span class="mt-auto mb-3 message-time">{{ formatDate(m.created_at) }}</span>

                      </div>
                    </div>
                  </div>
                  <div v-show="recruit.fase == 'waiting_interview'" class="col-12 text-center pb-4">
                      <b-alert class="w75 mx-auto" variant="info" show><a :href="interview.interview_url">面接を始める</a></b-alert>
                  </div>
                  <div v-show="recruit.fase == 'feedback'  && isFeedback == false" class="col-md-12 col-sm-12 pt-4">
                      <div class="text-center mx-auto">
                        <b-alert class="w50 mx-auto" variant="dark" show>
                            面接お疲れ様でした。フィードバックをして、採用可否を判定しましょう
                        </b-alert>
                      </div>
                  </div>
                </b-row>

              <div>

                <div v-if="recruit.fase == 'interview_adjustment'" class="col-12 text-center">
                    <p>企業様から面接の日程の候補が届いています。<br/>以下の日程からご都合の良い時間をお選びください</p>
                  <b-form-select v-model="selectDate" class="mt-3" :options="interviewOpts"></b-form-select>
                  <b-button v-show="selectDate != ''" @click="patchInterview" class='orange-button mt-3'>この内容で面接を決定する</b-button>
                </div>
                <div v-else-if="recruit.fase == 'feedback' && isFeedback == false" class="col-12 text-center">
                  <p>面接お疲れ様でした。企業へのフィードバックを行ってください。</p>
                  <b-form-select v-model="feedback.from_user_fb" class="mt-3 mb-3" :options="feedbackOpts"></b-form-select>
                  <b-form-textarea
                    v-model="feedback.from_user_comment"
                    placeholder="ここに面接のフィードバックを入力"
                    rows="3"
                  ></b-form-textarea>

                  <b-button v-show="feedback.from_user_fb == 'passed' || feedback.from_user_fb == 'denied'" @click="postFeedback" class='orange-button mt-3'>結果を送信</b-button>
                </div>
                <div v-else-if="recruit.fase == 'feedback' && recruit.state == 'denied'" class="col-12 text-center">
                </div>
                <div v-else class="col-12">
                  <div class="d-flex justify-content-between py-2 mt-4">
                    <input ref="file" type="file" style="display: none" @change="onSelectFile" accept="image/png, image/jpg, application/vnd.ms-excel, .csv, .pdf, image/jpeg,video/mp4">
                    <b-icon @click="$refs.file.click()" class="upload-icon" icon="card-image" font-scale="2"></b-icon>
                    <div>
                      <b-button @click="sendMessage" variant="secondary" size="sm">送信</b-button>
                    </div>
                  </div>

                  <div v-if="u_file == ''">
                  <b-form-textarea
                    v-model="mes"
                    placeholder="ここにメッセージを入力"
                    rows="6"
                  ></b-form-textarea>
                  </div>
                  <div v-else>
                    <b-alert variant="secondary" @dismissed="initializeFile" dismissible show>{{ file_name }}</b-alert>
                  </div>
                </div>

              </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import moment from 'moment'

export default {
  components: {
  },
  data () {
    return {
      messages: [],
      lists: [],
      mes: "",
      interview: {
        possible_dates1: "",
        possible_dates2: "",
        possible_dates3: "",
      },
      selectDate: "",
      interviewOpts: [],
      mainProps: { blank: true, blankColor: '#777', width: 50, height: 50, class: 'm1' },
      recruit: {},
      idToken: localStorage.idToken,
      current_organization_id: "",
      current_organization: {},
      isFeedback: false,
      u_file: "",
      file_name: "",
      mobileViewMode: "list",
      unreadNum: 0,
      isUnread: false,
      feedback: {
        from_user_fb: null,
        from_user_comment: null
      },
      feedbackOpts: [
          {value: "passed", text: "この会社で働きたい"},
          {value: "denied", text: "この会社で働きたくない"}
      ]
    }
  },
  methods: {
    formatDate: function(s) {
      return moment(s).format("HH:mm")
    },
    formatDate2: function(s) {
      return moment(s).format("Y年M月D日 HH:mm")
    },
    mobileCss: function(s) {
      if(this.mobileViewMode == "list" && s == "chatbox") {
        return "chatbox-hide"
      } else if(this.mobileViewMode == "detail" && s == "list") {
        return "list-hide"
      }

    },
    backList: function() {
      this.mobileViewMode = "list"
    },
    patchInterview: function( ) {
      this.$store.commit('setLoading', true)
      var p = {
        "interview_date": this.selectDate
      }
      axios
        .patch(process.env.VUE_APP_API + "/api/seeker/recruits/" + this.recruit.id + "/interviews/" + this.interview.id,{interview: p},{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.mes = ""
          this.fetch_messages({id: this.current_organization_id})
          this.$store.commit('setLoading', false)
        }).catch(error => {
          console.log('this is error', error)
        })

    },
    postFeedback: function() {
      this.$store.commit('setLoading', true)
      if(this.feedback.id == undefined) {
        axios
          .post(process.env.VUE_APP_API + "/api/seeker/recruits/" + this.recruit.id + "/interviews/" + this.interview.id + "/feedbacks",{feedback: this.feedback},{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.$store.commit('setLoading', false)
            this.fetch_messages({id: this.current_organization_id})
          }).catch(error => {
            console.log('this is error', error)
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API + "/api/seeker/recruits/" + this.recruit.id + "/interviews/" + this.interview.id + "/feedbacks/" + this.feedback.id,{feedback: this.feedback},{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.$store.commit('setLoading', false)
            this.fetch_messages({id: this.current_organization_id})
          }).catch(error => {
            console.log('this is error', error)
          })
      }
    },
    onSelectFile: function(event) {
      const files = event.target.files ? event.currentTarget.files : event.dataTransfer.files;
      const file = files[0];
      const reader = new FileReader();
      reader.onload = e => {
        this.u_file = e.target.result;
      };
      this.file_name = file.name;
      reader.readAsDataURL(file);
    },
    fetch_mailbox: function() {
      axios
        .get(process.env.VUE_APP_API + "/api/seeker/messages" ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.lists = response.data

        }).catch(error => {
          console.log('this is error', error)
        })
    },
    cancelInterview: function() {
      if(confirm("面接をキャンセルしますか？")) {
        this.$store.commit('setLoading', true)
        axios
          .delete(process.env.VUE_APP_API + "/api/seeker/recruits/" + this.recruit.id + "/interviews/" + this.interview.id,{ headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.fetch_messages({id: this.current_organization_id})
            this.interviewModal = false
            this.$store.commit('setLoading', false)
          }).catch(error => {
            console.log('this is error', error)
          })
      }
    },
    initializeFile: function() {
      this.u_file = ""
      this.file_name = ""
    },
    sendMessage: function() {
      if(this.mes == "" && this.u_file == "") {
        alert("空のメッセージは送れません")
        return 
      }
      this.$store.commit('setLoading', true)
      var arg = {
        "message": this.mes,
        "organization_id": this.current_organization_id
      }
      if(this.u_file != "") {
        arg["message_type"] = "file"
        arg["file_path"] = this.u_file
        arg["file_name"] = this.file_name
      }


      axios
        .post(process.env.VUE_APP_API + "/api/seeker/messages",{message: arg},{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.mes = ""
          this.fetch_messages({id: this.current_organization_id})
          this.initializeFile()
          this.$store.commit('setLoading', false)
        }).catch(error => {
          console.log('this is error', error)
        })
    },
    fetch_messages: function(l) {
      this.current_organization = l
      this.current_organization_id = l.id
      const url = new URL(window.location);
      url.searchParams.set('u_id', l.id);
      history.pushState({}, '', url);

      if(l.id != undefined) {
        this.mobileViewMode = 'detail'
      }

      axios
        .get(process.env.VUE_APP_API + "/api/seeker/messages/1?org_id=" + l.id ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.current_organization = response.data.org
          this.messages = response.data.messages
          response.data.messages.forEach((m) => {
            this.messages.push(m)
          })
          this.$bvToast.hide('new-message-toast')
          const container = this.$el.querySelector("#messageBox");

          container.scrollIntoView(true)
          container.scrollTo(0, container.scrollHeight);
        }).catch(error => {
          console.log('this is error', error)
        })

      this.feedback = {
        from_user_fb: null,
        from_user_comment: ""
      }
      this.interviewOpts = []
      axios
        .get(process.env.VUE_APP_API + "/api/seeker/recruits?org_id=" + l.id ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.recruit = response.data.recruits
          this.interview = response.data.interview || {possible_dates1: "", possible_dates2: "", possible_dates3: ""}

          response.data.feedback.forEach(feedback => {
            if(feedback.interview_id == this.interview.id) {
              this.feedback = feedback 
            }
          })

          if(this.feedback.id == undefined) {
            this.isFeedback = false 
          } else if(this.feedback.from_user_fb == null) {
            this.isFeedback = false 
          } else {
            this.isFeedback = true
          }

          this.interviewOpts.push({value: this.interview.possible_dates1, text: "第1希望"})
          this.interviewOpts.push({value: this.interview.possible_dates2, text: "第2希望"})
          this.interviewOpts.push({value: this.interview.possible_dates3, text: "第3希望"})
          this.interviewOpts.push({value: "no time", text: "希望に合う日程はありません"})
        }).catch(error => {
          console.log('this is error', error)
        })

    }

  },
  async mounted() {
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }
    var u_id = this.$route.query.u_id
    this.fetch_mailbox()
    this.fetch_messages({id: u_id})
    this.$store.commit('setLoading', false)

    setInterval( () => {
      if(this.current_organization.id != undefined) {
        axios
          .get(process.env.VUE_APP_API + "/api/seeker/message/check_new_messages?org_id=" + this.current_organization.id ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.unreadNum = response.data.unread_num
            if(this.unreadNum > 0 && this.isUnread == false) {
              this.isUnread = true
              this.$bvToast.show('new-message-toast')
            }
          })
      }

    }, 1000)




  },

  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language
    }),
  }
}
</script>

<style scoped lang="scss">
.thread-title{
  font-size: 1.3rem;
}
.black{
  color: #000000;
}
.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}
.thread-date {
  font-size: 0.9rem;
}

.w75 {
  width: 75%;
  p {
    overflow: auto;
  }
}
.w50 {
  width: 50%;
}
.w100 {
  width: 100%;
}

.mail-box-list {
  background-color: #fff;
  padding: 30px 20px;

  .box-title {
    color: #4D4D4D;
    font-size: 20px;
    font-weight: 600;
    text-align: center; 
  }
  .sub-title {
    color: #4D4D4D;
    font-size: 16px;
    font-weight: 100;
    text-align: center; 
  }
  .contact-line {
    background-color: #fff;
    border: none;
    border-top: 1px solid #B3B3B3;
    border-bottom: 1px solid #B3B3B3;
    padding: 0.75rem 1.25rem;

    .contact-name {
      color: #1A7BD5;
      padding: 0px 15px;
      font-weight: 500;
      margin-bottom: 0px;
    }
    .contact-description {
      font-size: 80%;
      color: #4D4D4D;
    }
  }
}
.user-message-baloon {
  border: 2px solid #4298F7;
  background-color: #FFFFFF;
  color: #4298F7;
  border-radius: 10px;
  margin-right: 5px;
}
.user-message-baloon:before {
  content: "";
  position: absolute;
  top: 50%;
  left: -21px;
  margin-top: -9px;
  border: 9px solid transparent;
  border-right: 13px solid #FFF;
  z-index: 2;
}
.user-message-baloon:after {
  content: "";
  position: absolute;
  top: 50%;
  left: -25px;
  margin-top: -10px;
  border: 10px solid transparent;
  border-right: 14px solid #4298F7;
  z-index: 1;
}
.org-message-baloon {
  border: 2px solid #B3B3B3;
  background-color: #FFFFFF;
  color: #4D4D4D;
  border-radius: 10px;
  margin-right: 30px;
  margin-left: 5px;
}
.org-message-baloon:before {
  content: "";
  position: absolute;
  top: 50%;
  right: -24px;
  margin-top: -12px;
  border: 12px solid transparent;
  border-left: 12px solid #FFF;
  z-index: 2;
}
.org-message-baloon:after {
  content: "";
  position: absolute;
  top: 50%;
  right: -30px;
  margin-top: -14px;
  border: 14px solid transparent;
  border-left: 14px solid #B3B3B3;
  z-index: 1;

}
.pl-250px {
  padding-left: 250px;
}
.current-mail {
  color: #1A7BD5;
}
.md-none {
  display: none;
}

@media (max-width: 991.98px) {
  .sm-none {
    display: none;
  }
  .md-none {
    display: block;
  }

  .chatbox-hide {
    display: none
  }
  .list-hide {
    display: none
  }
  .pl-250px {
    padding-left: 0px;
  }
  .w75 {
    width: 100%;
    margin: 10px 0px;

    p {
      overflow: auto;
    }
  }
  .w50 {
    width: 100%;
  }
}
.message-cotainer {
  margin: 0px 15px;
  padding: 0px 10px;
  height: 500px;
  overflow-y: scroll;
  border: 1px solid #ccc;
}
.logo_img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

</style>
